import FoiaRequest from './views/FoiaRequest';
import StatusCheck from './views/StatusCheck';

export default [
  { path: '/', redirect: '/foia-request' },
  { path: '/foia-request', component: FoiaRequest },
  { path: '/check-status', component: StatusCheck }
];
